export default __webpack_public_path__ + "static/media/news-image.e44f655e.jpg";